import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.299 4.167H12.7c.67 0 1.224 0 1.675.036.469.039.9.12 1.304.327.627.32 1.137.83 1.457 1.457.206.404.288.835.326 1.303.037.451.037 1.005.037 1.676V12.7c0 .67 0 1.224-.037 1.675-.038.469-.12.9-.326 1.304a3.33 3.33 0 0 1-1.457 1.457c-.405.206-.835.288-1.303.326-.452.037-1.005.037-1.676.037H7.3c-.67 0-1.225 0-1.676-.037-.468-.038-.899-.12-1.303-.326a3.33 3.33 0 0 1-1.457-1.457c-.206-.405-.288-.835-.326-1.303C2.5 13.925 2.5 13.372 2.5 12.7V8.966c0-.671 0-1.225.037-1.676.038-.468.12-.899.326-1.303.32-.628.83-1.137 1.457-1.457.404-.206.835-.288 1.303-.327.451-.036 1.005-.036 1.676-.036m-1.54 1.698c-.365.03-.552.084-.682.15-.314.16-.569.415-.729.728-.066.13-.12.317-.15.683-.03.375-.031.86-.031 1.574v3.667c0 .713 0 1.199.031 1.574.03.365.084.552.15.682.16.314.415.569.729.729.13.066.317.12.682.15.375.03.86.031 1.574.031h5.334c.713 0 1.199 0 1.574-.031.365-.03.552-.084.682-.15.314-.16.569-.415.729-.729.066-.13.12-.317.15-.682.03-.375.031-.86.031-1.574V9c0-.714 0-1.2-.031-1.574-.03-.366-.084-.552-.15-.683a1.67 1.67 0 0 0-.729-.728c-.13-.066-.317-.12-.682-.15-.375-.031-.86-.032-1.574-.032H7.333c-.713 0-1.199 0-1.574.032",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.5 3.333a.833.833 0 0 0-1.666 0V5a.833.833 0 0 0 1.667 0zM14.167 3.333a.833.833 0 0 0-1.666 0V5a.833.833 0 1 0 1.666 0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.667 10a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667m4.167-.833a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0m3.333 0a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0M10.834 12.5a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0m-4.167.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }